export enum ESharingContentType {
  Pick = 'Pick',
  List = 'List',
  Thought = 'Thought',
  User = 'User',
  Spark = 'Spark',
  GuestList = 'GuestList',
}
